import type { TBlueObj } from "@app/types/insider";
import type { TTrackTreeState } from "@app/types/insider";

export const invoicetrackrepo: TBlueObj<TTrackTreeState> = {
  name: "invoicetrack",
  initialState: {
    colorized: false,
    currentCurrency: null,
    currentEmitent: null, //abreviation
    currentItem: "0",
    includePrevious: false,
    trackCollectionFilter: "ALL",
    trackCollectionOverdueDays: 0,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
